import axios from 'axios';

const apiClient = axios.create({
  // eslint-disable-next-line no-undef
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
});

apiClient.defaults.withXSRFToken = true;
apiClient.defaults.withCredentials = true;

export default apiClient;
